import api from '@/store/helpers/api';

export default {
  state: {
    metrics: {
      leads: {},
      bestLeads: [],
      seo: {},
      worstSeo: [],
    },
  },
  mutations: {
    SET_METRICS_LEAD_NUMBERS(state, metricsLeads) {
      state.metrics.leads = metricsLeads;
    },
    SET_METRICS_BEST_LEAD_PAGES(state, metricsBestLeads) {
      state.metrics.bestLeads = metricsBestLeads;
    },
    SET_METRICS_SEO_TOTAL(state, metricsSeo) {
      state.metrics.seo = metricsSeo;
    },
    SET_METRICS_WORST_SEO_PAGES(state, metricsWorstSeo) {
      state.metrics.worstSeo = metricsWorstSeo;
    },
  },
  actions: {
    loadLeadNumbers({ commit }) {
      return new Promise((resolve, reject) => {
        api
          .get('/dashboard/metrics/leads')
          .then((response) => {
            const { data } = response;
            commit('SET_METRICS_LEAD_NUMBERS', data);
            resolve();
          })
          .catch(reject);
      });
    },
    loadBestLeadPages({ commit }) {
      return new Promise((resolve, reject) => {
        api
          .get('dashboard/metrics/ranking/leads?limit=5')
          .then((response) => {
            const { data } = response;
            commit('SET_METRICS_BEST_LEAD_PAGES', data);
            resolve();
          })
          .catch(reject);
      });
    },
    loadSeoTotal({ commit }) {
      return new Promise((resolve, reject) => {
        api
          .get('dashboard/metrics/seo')
          .then((response) => {
            const { data } = response;
            commit('SET_METRICS_SEO_TOTAL', data);
            resolve();
          })
          .catch(reject);
      });
    },
    loadWorstSeoPages({ commit }) {
      return new Promise((resolve, reject) => {
        api
          .get('dashboard/metrics/ranking/seo?limit=5')
          .then((response) => {
            const { data } = response;
            commit('SET_METRICS_WORST_SEO_PAGES', data);
            resolve();
          })
          .catch(reject);
      });
    },
  },
};
